import { GetStaticProps, InferGetStaticPropsType, NextPage } from "next";
import sanitize from "xss";

import { Seo } from "@/components";
import { AboutPageWithDetails, getAboutPage } from "@/features/content";

type Props = InferGetStaticPropsType<typeof getStaticProps>;

const AboutPage: NextPage<Props> = ({ about }) => (
  <>
    <Seo templateTitle={about.Heading} />

    <div className="container mt-10 mb-16">
      <h1 className="text-center text-4xl font-medium">{about.Heading}</h1>

      <div
        // The blog post body gets sanitized in GSSP and is safe to use.
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: about.Body }}
        className="prose mx-auto mt-8"
      />
    </div>
  </>
);

export const getStaticProps: GetStaticProps<{ about: AboutPageWithDetails }> = async () => {
  const about = await getAboutPage();
  about.Body = sanitize(about.Body);

  return {
    props: { about },
  };
};

export default AboutPage;
